import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const uploadSampleBot = async (payload) => {
    try{        
        let {id,name} = payload
        let { status } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/upload/?id=${id}&name=${name}`);               
        if (status === 200) {
            addNotification({
              title: "Techforce.ai",
              message: " Action Flow has been published successfully",
              type: "success"
            });
          }
        return status;
       }catch(e){
        console.log("errors", e)
        addNotification({
            title: "Techforce.ai",
            message: "Publishing Action Flow Failed",
            type: "danger"
          });      
    }
}
